// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-view{padding-bottom:3.125rem}.nav-view .nav-grid .van-grid-item .van-grid-item__text{font-size:1.125rem}.play104-img{background:#ba53cc}", ""]);
// Exports
module.exports = exports;
